import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { Router, NavigationExtras } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'ngx-modal-add-socio',
  templateUrl: './modal-add-socio.component.html',
  styleUrls: ['./modal-add-socio.component.scss'],
  providers: [PeticionesHttpBackEndService, UtilidadesService]
})



export class ModalAddSocioComponent implements OnInit {
  private valorSelect: number;
  myForm: FormGroup;
  constructor(private router:Router,public fb: FormBuilder, public utilidades: UtilidadesService, public dialogRef: MatDialogRef<ModalAddSocioComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, public _PeticionesHttpBackEndService: PeticionesHttpBackEndService, private authService: NbAuthService) { 
      this.nuevaEntidad = {Nombre:"",Apellidos:"",Email:"",EmpresaInstitucion: this.EsEmpresaInstitucion, EsSocio: this.EsSocio};
      this.myForm = this.fb.group({
        'nombreFisica':['',[Validators.required]],
        'apellidosFisica':['',[Validators.required]],
        'emailFisica':['',[Validators.required,Validators.email]],
        'nombreEmpresa':['',[Validators.required]],
        'dni':['',[Validators.required,Validators.pattern]],
        'emailEmpresa':['',[Validators.required,Validators.email]]
      });
  }

  TipologiasSelect: any;
  tokenRequest: any;
  nuevaEntidad: any;
  DeshabilitaBoton: Boolean = true;
  EsEmpresaInstitucion: Number = 0;
  EsSocio: Number = 0;
  nombreFisica :any = null;
  apellidosFisica:any = null;
  emailFisica:any = null;
  nombreEmpresa:any = null;
  dni:any = null;
  emailEmpresa:any = null;


  TipoEmpresaInstitucion = [
    { value: '0', label: 'Soy una persona física'},
    { value: '1', label: 'Soy una empresa o una institución'},
  ];


  TipoSocioNoSocio = [
    { value: '0', label: 'No socio'},
    { value: '1', label: 'Socio'},
  ];


  ngOnInit() {
    this.authService.getToken()
    .subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        this.tokenRequest = token;
      }
    }); 
  }

  email:any;
  setObjetonuevaEntidad(event){
    let resultado;
    let elemento = event.target.tagName;
    let tipo = event.target.type;
    if (elemento == "INPUT" && tipo == "text"){
      switch(event.target.name){
        case "_nombre": this.nuevaEntidad.Nombre = event.target.value; break;
        case "_apellidos": this.nuevaEntidad.Apellidos = event.target.value; break;
        case "_email": 
        this.email = event.target.value;
        /*this._PeticionesHttpBackEndService.postRequest("CheckEmailExist",{Data:{Email:event.target.value}}).subscribe(
          result => {
            resultado = result;
            if (resultado.Exist == true){
              this.utilidades.notificationWarning("Error","Este email ya existe en la base de datos, cada email debe ser único.","top-left");
              this.DeshabilitaBoton = true;
            }else{
              this.DeshabilitaBoton = false;
              this.nuevaEntidad.Email = event.target.value; 
            }
          },
          error => {

          }
        );*/

        break;
      }
    }

  }

  resultado:any;
  save(){
    this._PeticionesHttpBackEndService.postRequest("CheckEmailExist",{Data:{Email:this.email}}).subscribe(
      result => {
        this.resultado = result;
        if (this.resultado.Exist == true){
          this.utilidades.notificationWarning("Error","Este email ya existe en la base de datos, cada email debe ser único.","top-left");
          this.DeshabilitaBoton = true;
        }else{
          if ((this.EsEmpresaInstitucion == 0 && (this.myForm.get('nombreFisica').hasError('required') || this.myForm.get('apellidosFisica').hasError('required') 
          || (this.myForm.get('emailFisica').hasError('required') || this.myForm.get('emailFisica').hasError('email'))) 
          ||  this.EsEmpresaInstitucion == 1 && (this.myForm.get('nombreEmpresa').hasError('required') || (this.myForm.get('emailEmpresa').hasError('required') || this.myForm.get('emailEmpresa').hasError('email'))
          || (this.myForm.get('dni').hasError('pattern') || this.myForm.get('dni').hasError('pattern'))))){
            this.utilidades.notificationWarning("Error","Por favor, rellena todos los campos.","top-left");
          }else{
      
            this._PeticionesHttpBackEndService.postRequest("v1/admin/nuevaEntidad",{Data: {"NombreFisica":this.myForm.value.nombreFisica,"EmailFisica":this.myForm.value.emailFisica,"ApellidosFisica":this.myForm.value.apellidosFisica,
            "NombreEmpresa":this.myForm.value.nombreEmpresa,"Dni":this.myForm.value.dni,"EmailEmpresa":this.myForm.value.emailEmpresa,"EsEmpresaInstitucion":this.EsEmpresaInstitucion,
            "EsSocio":this.EsSocio}}).subscribe(
              result => {
                let resultado;
                resultado = result;
                if (resultado.Code == 500){
                  this.utilidades.notificationWarning("Error",""+resultado.message+"","top-left");
                }else{
                  this.utilidades.notificationSuccess("Éxito","Socio creado con éxito","top-left");
                  let parametros: NavigationExtras = {
                    queryParams: { 'EntidadId': resultado.Entidad._entidad_id }
                  };
                  this.router.navigate(['private/admin-datos-entidad'], parametros);
                  
                
                } 
              },
              error => {
                if (error.error.code == 401){
                  this.router.navigate(['auth/login']);
                  /* Si hay un error 401 es que el token no es válido, por lo tanto, redirecciono a login */
                  //this.router.navigate(['/auth/login']);
              }
              }
            );
            
            this.dialogRef.close();
          }
        }
      },
      error => {

      }
    );

  }

  close(){
    this.dialogRef.close();
  }

}
